var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col items-start justify-between space-y-4 sm:flex-row sm:items-center sm:space-x-4 sm:space-y-0"},[_c('div',{staticClass:"flex h-10 w-full items-center space-x-4 sm:w-auto"},[_c('search-input-component',{staticClass:"w-full",attrs:{"value":_vm.getSearchFilter},on:{"input":_vm.setSearchFilter}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }